import React from 'react';
import NotFound from 'pages/error-pages/404';

const PermissionRoute = ({ permission, component }) => {
  return permission ? component : <NotFound />;
};

export default PermissionRoute;
